/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchVerifyUnipassPersonReqVo
 */
export interface BatchVerifyUnipassPersonReqVo {
    /**
     * 个人通关号
     * @type {string}
     * @memberof BatchVerifyUnipassPersonReqVo
     */
    persEcm?: string;
    /**
     * 姓名
     * @type {string}
     * @memberof BatchVerifyUnipassPersonReqVo
     */
    pltxNm?: string;
    /**
     * 手机号
     * @type {string}
     * @memberof BatchVerifyUnipassPersonReqVo
     */
    cralTelno?: string;
    /**
     * 邮编
     * @type {string}
     * @memberof BatchVerifyUnipassPersonReqVo
     */
    zip?: string;
}

/**
 * Check if a given object implements the BatchVerifyUnipassPersonReqVo interface.
 */
export function instanceOfBatchVerifyUnipassPersonReqVo(value: object): value is BatchVerifyUnipassPersonReqVo {
    return true;
}

export function BatchVerifyUnipassPersonReqVoFromJSON(json: any): BatchVerifyUnipassPersonReqVo {
    return BatchVerifyUnipassPersonReqVoFromJSONTyped(json, false);
}

export function BatchVerifyUnipassPersonReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchVerifyUnipassPersonReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'persEcm': json['persEcm'] == null ? undefined : json['persEcm'],
        'pltxNm': json['pltxNm'] == null ? undefined : json['pltxNm'],
        'cralTelno': json['cralTelno'] == null ? undefined : json['cralTelno'],
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function BatchVerifyUnipassPersonReqVoToJSON(json: any): BatchVerifyUnipassPersonReqVo {
    return BatchVerifyUnipassPersonReqVoToJSONTyped(json, false);
}

export function BatchVerifyUnipassPersonReqVoToJSONTyped(value?: BatchVerifyUnipassPersonReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'persEcm': value['persEcm'],
        'pltxNm': value['pltxNm'],
        'cralTelno': value['cralTelno'],
        'zip': value['zip'],
    };
}

